import React, { useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import {
  fetchRightSidebarData,
  fetchRightSidebarSubcategories,
  selectRightSubcategory,
  setSlidingState,
} from "../actions/rightSidebarActions";

import "../css/rightsidebar.css";

const RightSidebar = ({
  isOpen,
  toggleSidebar,
  categories = [],
  subcategories = {},
  activeSlide,
  isSliding,
  fetchRightSidebarData,
  fetchRightSidebarSubcategories,
  selectRightSubcategory,
  setSlidingState,
  menuItems = [],
  user,
  onLogout,
}) => {
  /* ================= LOAD MAIN CATEGORIES ================= */
  useEffect(() => {
    fetchRightSidebarData();
  }, [fetchRightSidebarData]);

  /* ================= OPEN SLIDE ================= */
  const openSlide = async (categoryId) => {
    const category = categories.find((c) => c.category_id === categoryId);
    if (!category?.has_slide) return;

    if (!subcategories[categoryId]) {
      try {
        await fetchRightSidebarSubcategories(categoryId);
      } catch (e) {
        console.error("Failed to fetch subcategories:", e);
        return;
      }
    }

    setSlidingState(false);
    selectRightSubcategory(categoryId);

    setTimeout(() => {
      setSlidingState(true);
    }, 200);
  };

  /* ================= CLICK HANDLERS ================= */
  const handleClickCategory = (categoryId, e) => {
    e.preventDefault();
    openSlide(categoryId);
  };

  const handleSubcategoryClick = () => {
    toggleSidebar();
    selectRightSubcategory(null);
    setSlidingState(false);
  };

  const handlePrimaryLinkClick = () => {
    toggleSidebar();
  };

  const handleLogoutClick = async () => {
    if (onLogout) {
      await onLogout();
      toggleSidebar();
    }
  };

  return (
    <div className={`sidebar-wrapper ${isOpen ? "open" : "hidden"}`}>
      {/* ================= SLIDE PANEL ================= */}
      <div className={`slide-container ${isSliding ? "show" : ""}`}>
        {activeSlide && subcategories[activeSlide]?.length > 0 && (
          <div className="industries-container">
            <h2>
              {
                categories.find(
                  (cat) => cat.category_id === activeSlide
                )?.category_name
              }
            </h2>

            <ul className="industries-grid">
              {subcategories[activeSlide].map((sub) => (
                <li key={sub.category_id}>
                  <Link
                    to={`/subcategory/${sub.slug}`}
                    className="subcategory-link"
                    onClick={handleSubcategoryClick}
                  >
                    {sub.category_name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* ================= RIGHT SIDEBAR ================= */}
      <div className="right-sidebar">
        {/* ===== TOP HEADER (LOGO + CLOSE) ===== */}
        <div className="sidebar-top">
          <div className="sidebar-logo">
            <img
              src="/images/company_logo.png"
              alt="Dihan Tech"
              className="sidebar-logo-img"
            />
          </div>

          <IoClose
            className="close-icon"
            onClick={() => {
              toggleSidebar();
              selectRightSubcategory(null);
              setSlidingState(false);
            }}
          />
        </div>

        {/* ===== MENU SCROLL AREA ===== */}
        <div className="right-sidebar-scroll">
          {/* PRIMARY LINKS */}
          <nav className="mobile-nav-links">
            {menuItems.slice(1, 5).map((menu, index) => (
              <Link
                key={index}
                to={menu.path}
                onClick={handlePrimaryLinkClick}
              >
                {menu.title}
              </Link>
            ))}

            {user ? (
              <button className="mobile-logout" onClick={handleLogoutClick}>
                Logout
              </button>
            ) : (
              <Link to="/login" onClick={handlePrimaryLinkClick}>
                {menuItems[5]?.title || "Sign in"}
              </Link>
            )}
          </nav>

          <div className="sidebar-divider" />

          {/* CATEGORY LIST */}
          <nav className="sidebar-menu">
            <ul>
              {categories
                .filter((cat) => cat.parent_id === null)
                .map((category) => (
                  <li key={category.category_id}>
                    <Link
                      to="#"
                      className="menu-item"
                      onClick={(e) =>
                        handleClickCategory(category.category_id, e)
                      }
                    >
                      {category.category_name}
                    </Link>
                  </li>
                ))}
            </ul>
          </nav>
             </div>
               </div>
                  </div>
  );
};

/* ================= REDUX ================= */
const mapStateToProps = (state) => ({
  categories: state.rightSidebar?.data || [],
  subcategories: state.rightSidebar?.subcategories || {},
  activeSlide: state.rightSidebar?.selectedSubcategory,
  isSliding: state.rightSidebar?.isSliding,
});

export default connect(mapStateToProps, {
  fetchRightSidebarData,
  fetchRightSidebarSubcategories,
  selectRightSubcategory,
  setSlidingState,
})(RightSidebar);
